import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { iif, of, ReplaySubject, Subject } from 'rxjs';
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnDestroy/* implements AfterViewInit, OnDestroy, OnInit */ {

  private _selection: any;
  private _selectionCheck: any[] = [];
  public DataCtrl: UntypedFormControl = new UntypedFormControl();
  public DataFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public DataFilterCtrlCheck: UntypedFormControl = new UntypedFormControl();

  @Output() readonly selectionChangeCheck = new EventEmitter<Itemcheck[]>(true);
  @Output() readonly selectionChange = new EventEmitter<any>(true);
  @Input()
  set selection(newSel: any) {
    this._selection = newSel;
    this.selectionChange.emit(newSel);
  }
  get selection(): any {
    return this._selection;
  }
  @Input()
  set selectionCheck(newSel: any[]) {
    this._selectionCheck = newSel;
    this.selectionChangeCheck.emit(newSel);
  }
  get selectionCheck(): any[] {
    return this._selectionCheck;
  }
  @ViewChild('multiSelect', { static: true })
  multiSelect!: MatSelect;

  @Input() optional = true;
  @Input() optOneItemSeleccione = true;
  @Input() multiples = false;
  @Output() itemClick = new EventEmitter<any>(true);
  @Output() listitemClick = new EventEmitter<any[]>(true);

  _items: any[] | null | undefined = [];
  @Input()
  public set items(newItems: any[] | null | undefined) {
    if (this.selection && this._items) {
      this.selection = undefined;
      this.onClick(undefined);
    }
    this._items = newItems;
    if ((newItems && newItems.length == 1) && this.optOneItemSeleccione) {
      this._disabled = true;
      this.selection = newItems[0][this.value];
      this.onClick(newItems[0]);
      this.filter.next(newItems.slice);
    }
  }
  @Input()
  public set itemsWithCheck(newItems: any[] | null | undefined) {
    let index = 0;
    newItems?.forEach(
      x => {
        if (x) {
          this._items?.push(
            {
              x: x,
              check: false,
              index: (index = index + 1)
            }
          )
        }
      }
    )
    if (this.selection) {
      this.selection = undefined;
      this.onClick2(undefined);
    }
    if (this._items && this._items.length == 1) {
      this.selection = this._items[0].x[this.value];
      this.onClick2(this._items[0]);
      this.filter.next(this._items.slice);
    }
  }

  ngAfterViewInit() {
  }

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this.filter.next();
    this.filter.complete();
  }

  @Input() titulo?: string;
  @Input() text = 'text';
  @Input() value = 'value';

  _disabled = false;
  @Input()
  public set disabled(v: boolean) {
    this._disabled = v;
  }

  public get disabled(): boolean {
    return this._disabled || !this._items || this._items.length <= 0
  }

  @Input() search = false;

  filter = new ReplaySubject<any>();

  public get items$() {
    return iif(
      () => this.search,
      of(this.filterData(this._items)),
      of(this._items)
    );
  }

  public get itemsCheck$() {
    return iif(
      () => this.search,
      of(this.filterDataCheck(this._items)),
      of(this._items)
    );
  }

  filterData(_itemsFilter: any[] | null | undefined): any[] | null | undefined {
    //se agrega validación que impida ingresar en los posible casos que la página no halla cargado los diferentes 
    //componentes necesarios para filtrar la información ha análizar.
    let self = this;
    if (_itemsFilter && _itemsFilter.length > 0 && this.DataFilterCtrl.value != "") {
      if (this.DataFilterCtrl.value) {
        //cadena en minusculas para que sea analizada y sea filtrada
        /* return _itemsFilter.filter(y => y[this.text].toString().toLowerCase().
          includes(this.DataFilterCtrl.value.toString().toLowerCase())); */

        var data: string = this.DataFilterCtrl.value.toString();

        var d = data.split(" ");

        d.forEach(element => {
          if (_itemsFilter)
            _itemsFilter = _itemsFilter.filter(y => y[this.text].toString().toLowerCase().
              includes(element.toString().toLowerCase()));
        });

        return _itemsFilter;
      }
    }
    return _itemsFilter;
  }

  filterDataCheck(_itemsFilter: Itemcheck[] | null | undefined): any[] | null | undefined {
    //se agrega validación que impida ingresar en los posible casos que la página no halla cargado los diferentes 
    //componentes necesarios para filtrar la información ha análizar.
    let self = this;
    let text = this.text;
    let enviar = _itemsFilter;

    /*     this.DataFilterCtrlCheck.valueChanges.subscribe(
          ()=>{
            if(_itemsFilter&&_itemsFilter.length>0&&self.DataFilterCtrlCheck.value!=""){
              if(self.DataFilterCtrlCheck.value){
                //cadena en minusculas para que sea analizada y sea filtrada
                enviar=_itemsFilter.filter(y => y.x[text].toString().toLowerCase().
                includes(self.DataFilterCtrlCheck.value.toString().toLowerCase()));
                return _itemsFilter.filter(y => y.x[text].toString().toLowerCase().
                includes(self.DataFilterCtrlCheck.value.toString().toLowerCase()));
              }
            }
            return enviar;
          }
        )
        return enviar; */
    if (_itemsFilter && _itemsFilter.length > 0 && this.DataFilterCtrlCheck.value != "") {
      if (this.DataFilterCtrlCheck.value) {

        //cadena en minusculas para que sea analizada y sea filtrada
        /* return _itemsFilter.filter(y => y.x[this.text].toString().toLowerCase().
          includes(this.DataFilterCtrlCheck.value.toString().toLowerCase())); */

        var data: string = this.DataFilterCtrlCheck.value.toString();

        var d = data.split(" ");

        d.forEach(element => {
          if (_itemsFilter)
            _itemsFilter = _itemsFilter.filter(y => y.x[this.text].toString().toLowerCase().
              includes(element.toString().toLowerCase()));
        });

        return _itemsFilter;

      }
    }
    return _itemsFilter;
  }


  onClick(item: any) {
    this.itemClick.emit(item);
  }

  onClick2(item: any) {
    let search = 0;

    if (item) {
      if (item.check == true) {
        item.check = false;
      } else {
        item.check = true;
      }
    } else {
      item.check = true;
    }

    if (this._items) {
      //buscamos
      search = this._items.findIndex(
        x => x.index == item.index
      )
      //luego cambiamos el estado elemento de la lista 
      if (search != -1) {
        this._items[search].check = item.check;
      }
      this.listitemClick.emit(this._items.filter(x => x.check == true));
    }
  }

}

interface Itemcheck {
  x: any
  check: boolean,
  index: number
}